<template>
  <ion-select v-if="roundSelection.length > 1" class="mt-20 mb-2 ml-2 round-filter" placeholder="Select Round" v-model="filterRound">
    <ion-select-option v-for="round in roundSelection" :key="round.value" :value="round.value">{{ round.text }}</ion-select-option>
  </ion-select>
  <!-- <table-grid-mobile-with-search title="Test Mobile Table" :headers="['Goal', 'Penalty', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10', 'T11', 'T12']"
  :rows="[
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  ]"/> -->
  <table-grid-mobile-with-search
  :title="sportLadder.label"
  v-if="isMultiSport"
  :headers="sportLadder.headers"
  :rows="sportLadder.rows"/>
  <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none" v-if="
    useSortOptions === false &&
    !isMultiSport &&
    ((ladder.competition && !ladder.competition.hasPools)
    ||
    (ladder.competition && ladder.competition.hasPools && (!teamsByPool || Object.keys(teamsByPool) === 0)))
  ">
    <div class="table-grid-container">
      <div class="ladder-row header-row notranslate">
        <div class="sticky-team-info">
          <div class="team-logo-column">
            <span class="stats-header"></span>
          </div>
          <div class="place">
            <span class="stats-header">No.</span>
          </div>
          <div class="team-name">
            <span class="stats-header">Name</span>
          </div>
        </div>
        <div class="stats-cell"><span class="stats-header">Pl</span></div>
        <div class="stats-cell"><span class="stats-header">W</span></div>
        <div class="stats-cell"><span class="stats-header">D</span></div>
        <div class="stats-cell"><span class="stats-header">L</span></div>
        <div class="stats-cell" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed"><span class="stats-header">BP</span></div>
        <div class="stats-cell"><span class="stats-header">Pts</span></div>
        <div class="stats-cell"><span class="stats-header">+</span></div>
        <div class="stats-cell"><span class="stats-header">-</span></div>
      </div>
      <div class="team-wrapper" v-for="(team, index) in teamsArrangeByPosition" :key="team._id">
        <div class="ladder-row">
          <div class="sticky-team-info">
            <div class="team-logo-column">
              <img class="club-logo" :src="get(team, 'meta.imgUrl', clubPlaceholder)" />
            </div>
            <div class="place">
              <span class="stats">
                {{ index + 1 }}
                <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
                </svg>
              </span>
            </div>
            <div class="team-name notranslate">
              <span class="stats">{{ team.name }}</span>
            </div>
          </div>
          <div class="stats-cell"><span class="stats">{{ team.stats.matchesPlayed }}</span></div>
          <div class="stats-cell"><span class="stats">{{ team.stats.matchesWon }}</span></div>
          <div class="stats-cell"><span class="stats">{{ team.stats.matchesDrawn }}</span></div>
          <div class="stats-cell"><span class="stats">{{ team.stats.matchesLost }}</span></div>
          <div class="stats-cell" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed"><span class="stats">{{ team.stats.pointsBonus }}</span></div>
          <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.totalMatchPoints >= 0 ? `${team.stats.totalMatchPoints}` : `${team.stats.totalMatchPoints}`}}</span></div>
          <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.pointsFor }}</span></div>
          <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.pointsAgainst }}</span></div>
        </div>
      </div>
    </div>
  </ion-list>


  <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none" v-if="
    useSortOptions === true &&
    !isMultiSport &&
    ((ladder.competition && !ladder.competition.hasPools)
    ||
    (ladder.competition && ladder.competition.hasPools && (!teamsByPool || Object.keys(teamsByPool) === 0)))
  ">
    <div class="table-grid-container">
      <div class="ladder-row header-row notranslate">
        <div class="sticky-team-info">
          <div class="team-logo-column">
            <span class="stats-header"></span>
          </div>
          <div class="place">
            <span class="stats-header">No.</span>
          </div>
          <div class="team-name">
            <span class="stats-header">Name</span>
          </div>
        </div>
        <div class="stats-cell" v-for="(header, hIdx) in headersSelected" :key="hIdx">
          <span class="stats-header">{{ header }}</span>
        </div>
      </div>
      <div class="team-wrapper" v-for="(team, index) in teamsArrangeByPosition" :key="team._id">
        <div class="ladder-row">
          <div class="sticky-team-info">
            <div class="team-logo-column">
              <img class="club-logo" :src="get(team, 'meta.imgUrl', clubPlaceholder)" />
            </div>
            <div class="place">
              <span class="stats">
                {{ index + 1 }}
                <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
                </svg>
              </span>
            </div>
            <div class="team-name notranslate">
              <span class="stats">{{ team.name }}</span>
            </div>
          </div>
          <div class="stats-cell" v-for="(value, vIdx) in teamStats(team)" :key="vIdx">
            <span class="stats stats-pts">{{ value }}</span>
          </div>
        </div>
      </div>
    </div>
  </ion-list>

  <div v-if="useSortOptions === true &&
    !isMultiSport &&
    (ladder.competition && ladder.competition.hasPools)">
    <ion-list
      class="mt-20 mb-2 ladder-wrapper" lines="none"
      :hidden="isMultiSport"
      v-for="pool in filteredPools"
      :key="processPoolNameSortOptions(pool)">
      <div class="table-grid-container">
        <ion-list-header class="pool-name"> {{ processPoolName(pool) }} </ion-list-header>
        <div class="ladder-row header-row notranslate">
          <div class="sticky-team-info">
            <div class="team-logo-column">
              <span class="stats-header"></span>
            </div>
            <div class="place">
              <span class="stats-header">No.</span>
            </div>
            <div class="team-name">
              <span class="stats-header">Name</span>
            </div>
          </div>
          <div class="stats-cell" v-for="(header, hIdx) in headersSelected" :key="hIdx">
            <span class="stats-header">{{ header }}</span>
          </div>
        </div>
        <div class="team-wrapper" v-for="(team, index) in teamsByPool[pool]" :key="team._id">
          <div class="ladder-row">
            <div class="sticky-team-info">
              <div class="team-logo-column">
                <img class="club-logo" :src="get(team, 'meta.imgUrl', clubPlaceholder)" />
              </div>
              <div class="place">
                <span class="stats">
                  {{ index + 1 }}
                  <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
                  </svg>
                </span>
              </div>
              <div class="team-name notranslate">
                <span class="stats">{{ team.name }}</span>
              </div>
            </div>
            <div class="stats-cell" v-for="(value, vIdx) in teamStats(team)" :key="vIdx">
              <span class="stats stats-pts">{{ value }}</span>
            </div>
          </div>
          <transition-group name="fade">
            <div class="ladder-row" v-show="ladder.teams.find(t => t._id === team._id).display" :key="key">
              <div class="stats-cell"><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></div>
              <div class="stats-cell"><span class="stats"> B : {{ team.stats.byes }} </span></div>
            </div>
          </transition-group>
        </div>
      </div>
    </ion-list>
  </div>

  <div v-if="useSortOptions === false && !isMultiSport && (ladder.competition && ladder.competition.hasPools)">
    <ion-list
      class="mt-20 mb-2 ladder-wrapper" lines="none"
      :hidden="isMultiSport"
      v-for="pool in filteredPools"
      :key="processPoolName(pool)">
      <div class="table-grid-container">
        <ion-list-header class="pool-name"> {{ processPoolName(pool) }} </ion-list-header>
        <div class="ladder-row header-row notranslate">
          <div class="sticky-team-info">
            <div class="team-logo-column">
              <span class="stats-header"></span>
            </div>
            <div class="place">
              <span class="stats-header">No.</span>
            </div>
            <div class="team-name">
              <span class="stats-header">Name</span>
            </div>
          </div>
          <div class="stats-cell"><span class="stats-header">Pl</span></div>
          <div class="stats-cell"><span class="stats-header">W</span></div>
          <div class="stats-cell"><span class="stats-header">D</span></div>
          <div class="stats-cell"><span class="stats-header">L</span></div>
          <div class="stats-cell" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed"><span class="stats-header">BP</span></div>
          <div class="stats-cell"><span class="stats-header">Pts</span></div>
          <div class="stats-cell"><span class="stats-header">+</span></div>
          <div class="stats-cell"><span class="stats-header">-</span></div>
        </div>
        <div class="team-wrapper" v-for="(team, index) in teamsByPool[pool]" :key="team._id">
          <div class="ladder-row">
            <div class="sticky-team-info">
              <div class="team-logo-column">
                <img class="club-logo" :src="get(team, 'meta.imgUrl', clubPlaceholder)" />
              </div>
              <div class="place">
                <span class="stats">
                  {{ index + 1 }}
                  <svg width="5" height="4" viewBox="0 0 5 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2.5" cy="2" r="2" fill="#B6B6B6"/>
                  </svg>
                </span>
              </div>
              <div class="team-name notranslate">
                <span class="stats">{{ team.name }}</span>
              </div>
            </div>
            <div class="stats-cell"><span class="stats">{{ team.stats.matchesPlayed }}</span></div>
            <div class="stats-cell"><span class="stats">{{ team.stats.matchesWon }}</span></div>
            <div class="stats-cell"><span class="stats">{{ team.stats.matchesDrawn }}</span></div>
            <div class="stats-cell"><span class="stats">{{ team.stats.matchesLost }}</span></div>
            <div class="stats-cell" v-if="ladder.competition.laddertemplate.bonusCountAsPlayed"><span class="stats">{{ team.stats.pointsBonus }}</span></div>
            <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.totalMatchPoints >= 0 ? `${team.stats.totalMatchPoints}` : `${team.stats.totalMatchPoints}`}}</span></div>
            <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.pointsFor }}</span></div>
            <div class="stats-cell"><span class="stats stats-pts">{{ team.stats.pointsAgainst }}</span></div>
          </div>
          <transition-group name="fade">
            <div class="ladder-row" v-show="ladder.teams.find(t => t._id === team._id).display" :key="key">
              <div class="stats-cell"><span class="stats"> Diff : {{ team.stats.pointsDifference >= 0 ? `+${team.stats.pointsDifference}` : `${team.stats.pointsDifference}`}} </span></div>
              <div class="stats-cell"><span class="stats"> B : {{ team.stats.byes }} </span></div>
            </div>
          </transition-group>
        </div>
      </div>
    </ion-list>
  </div>

</template>

<script>
import _ from 'lodash';
import TableGridMobileWithSearch from '@/components/TableGridMobileWithSearch';

const sortBy = [
  { name: 'Total Match Points', value: 'totalMatchPoints', abbreviation: 'Pts' },
  { name: 'Points Difference', value: 'pointsDifference', abbreviation: '+/-' },
  { name: 'Points For', value: 'pointsFor', abbreviation: '+' },
  { name: 'Points Against', value: 'pointsAgainst', abbreviation: '-' },
  { name: 'Points Bonus', value: 'pointsBonus', abbreviation: 'BP' },
  { name: 'Matches Played', value: 'matchesPlayed', abbreviation: 'P' },
  { name: 'Matches Won', value: 'matchesWon', abbreviation: 'W' },
  { name: 'Matches Lost', value: 'matchesLost', abbreviation: 'L' },
  { name: 'Matches Drawn', value: 'matchesDrawn', abbreviation: 'D' },
  { name: 'BYES', value: 'byes', abbreviation: 'B' },
  { name: 'Score Ratio', value: 'scoreRatio', abbreviation: 'SR' },
  { name: 'Points Ratio', value: 'pointsRatio', abbreviation: 'PR' },
  { name: 'Number Of Forfeits', value: 'numberOfForfeits', abbreviation: 'FF' },
  { name: 'Number Forfeits Win', value: 'numberForfeitsWin', abbreviation: 'FW' },
  { name: 'Number Forfeits Loss', value: 'numberForfeitsLoss', abbreviation: 'FL' },
  { name: 'Points Difference Percentage', value: 'pointsDifferencePercentage', abbreviation: '%' },
];

export default {
  name: 'LadderView',
  components: {
    TableGridMobileWithSearch
  },
  props: {
    ladder: {
      type: Object,
      required: true,
    },
    sportLadder: {
      type: Object,
      required: false,
    },
    selectedPool: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      key: 0,
      get: _.get,
      filterRound: 0,
    }
  },
  mounted() {
    console.log('LadderView mounted', this.ladder);
  },
  methods: {
    processPoolName(name) {
      return name !== 'undefined' ? name : 'Unknown Pool';
    },
    processPoolNameSortOptions(name) {
      return name !== 'undefined' ? name : 'Unknown Pool';
    },
    flipDisplay(teamId) {
      if (!this.ladder.teams) return;
      const index = this.ladder.teams.findIndex(t => t._id === teamId);
      if (this.ladder.teams[index].display) {
        // eslint-disable-next-line vue/no-mutating-props
        this.ladder.teams[index].display = false;
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.ladder.teams[index].display = true;
      }
      this.key++
    },
    teamStats(team) {
      const teamStats = _.get(team, 'stats', {});
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      // const sortBy = _.get(this.ladder, 'competition.laddertemplate.sortBy', []);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
      }
      // const filterSortBy = _.filter(sortBy, (item) => _.includes(selectedSortByOptions, item.value));
      const stats = [];
      for (const item of selectedSortByOptions) {
        const value = _.get(teamStats, item, 0);
        stats.push(value);
      }
      return stats;
    }
  },
  computed: {
    clubPlaceholder() {
      return process.env.VUE_APP_PLACEHOLDER;
    },
    roundSelection() {
      const maxRound = _.get(this.ladder, 'teamsWithStatsByRound.maxRound', 0);
      const rounds = [];
      rounds.push({
        text: 'All Rounds',
        value: 0,
      });
      // eslint-disable-next-line no-restricted-syntax
      for (let i = 1; i <= maxRound; i++) {
        rounds.push({
          text: `Round ${i}`,
          value: i,
        });
      }
      return rounds;
    },
    selectedSortByOptions() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      if (useSortOptionsCompType) {
        return _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortByOptions', []);
      }
      return _.get(this.ladder, 'competition.laddertemplate.selectedSortByOptions', []);
    },
    useSortOptions() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      if (useSortOptionsCompType) {
        const selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
        return useSortOptionsCompType && selectedSortByOptions.length > 0;
      }
      const selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      return _.get(this.ladder, 'competition.laddertemplate.useSortOptions', false) && selectedSortByOptions.length > 0;
    },
    headersSelected() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortOptionsSorted', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortOptionsSorted', []);
      }
      console.log({
        headersSelected: selectedSortByOptions,
      });
      const filterSortBy = [];
      for (const item of selectedSortByOptions) {
        const foundItem = _.find(sortBy, (sortByItem) => {
          console.log({
            sortByItemValue: sortByItem.value,
            item,
          });
          return sortByItem.value === item
        });
        console.log({
          item,
          foundItem,
        });
        if (foundItem) filterSortBy.push(foundItem);
      }
      console.log({
        sortBy,
        filterSortBy,
        selectedSortByOptions,
      });
      const mappedHeaders = _.map(filterSortBy, (item) => {
        const header = _.get(item, 'abbreviation');
        if (header) return header;
        // Get name, get first letter of each word
        const name = _.get(item, 'name', '');
        return name.split(' ').map((word) => word[0]).join('');
      });
      console.log({
        mappedHeaders,
        selectedSortByOptions,
        filterSortBy,
      });
      return mappedHeaders;
    },
    teamsByPool() {
      // Use the same ranking for pooled and non-pooled ladders, matching admin.
      const teams = this.teamsArrangeByPosition;
      return teams
        ? teams.reduce((result, item) => {
          const value = item.pool;
          result[value] = (result[value] || []).concat(item);
          return result;
        }, {}) : false;
    },
    isMultiSport() {
      const headers = _.get(this.sportLadder, 'headers', []);
      const rows = _.get(this.sportLadder, 'rows', []);
      if (headers.length > 0 && rows.length > 0) {
        return true;
      }
      return false;
    },
    teamsArrangeByPosition() {
      const useSortOptionsCompType = _.get(this.ladder, 'competition.compTypeLaddertemplate.useSortOptions', false);
      let selectedSortByOptions = _.get(this.ladder, 'competition.laddertemplate.selectedSortByOptions', []);
      if (useSortOptionsCompType) {
        selectedSortByOptions = _.get(this.ladder, 'competition.compTypeLaddertemplate.selectedSortByOptions', []);
      }
      if (!selectedSortByOptions || selectedSortByOptions.length === 0) {
        const sortByOptions = _.get(this.ladder, 'competition.laddertemplate.sortBy');
        const mappedStatsSortByOptions = _.map(sortByOptions, 'value');
        selectedSortByOptions = mappedStatsSortByOptions;
      }
      if (!selectedSortByOptions || selectedSortByOptions.length === 0) {
        selectedSortByOptions = sortBy;
      }
      let iteratees = selectedSortByOptions.map((item) => `stats.${item}`);
      if (selectedSortByOptions.length > 0) {
        // Check if items in selectedSortByOptions object or string, if object then map to value
        if (typeof selectedSortByOptions[0] === 'object') {
          iteratees = selectedSortByOptions.map((item) => `stats.${item.value}`);
        }
      }
      const orders = selectedSortByOptions.map(() => 'desc');
      const roundSelected = this.filterRound;
      if (!roundSelected || roundSelected === 0) {
        const teams = _.orderBy(this.ladder.teams, iteratees, orders);
        return teams;
      }
      const roundTeams = _.get(this.ladder, `teamsWithStatsByRound.perRound.${roundSelected}`, []);
      return _.orderBy(roundTeams, iteratees, orders);
    },
    isAllPools() {
      // Check if no pool is selected or if "All Pools" is selected
      return !this.selectedPool || this.selectedPool.name === 'All Pools';
    },
    filteredPools() {
      if (!this.teamsByPool) {
        return [];
      }

      if (this.isAllPools) {
        // Filter out undefined keys and ensure we have valid pools
        const validPools = Object.keys(this.teamsByPool).filter(key =>
          key !== 'undefined' &&
          this.teamsByPool[key] &&
          Array.isArray(this.teamsByPool[key]) &&
          this.teamsByPool[key].length > 0
        );
        const configuredOrder = _.get(this.ladder, 'poolOrder', []);
        const configuredPools = configuredOrder.filter(poolName => validPools.includes(poolName));
        const remainingPools = _.difference(validPools, configuredPools)
          .sort((left, right) => left.localeCompare(right, undefined, {
            numeric: true,
            sensitivity: 'base',
          }));
        return [...configuredPools, ...remainingPools];
      } else if (this.selectedPool) {
        return [this.selectedPool.name];
      }
      return [];
    },
  }
};
</script>

<style scoped lang="scss">

/* Assemble Sports Fonts */
@font-face {
	font-family: 'BrownStd-Bold';
	src: url('../assets/fonts/BrownStd-Bold.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Regular';
	src: url('../assets/fonts/BrownStd-Regular.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
	font-family: 'BrownStd-Light';
	src: url('../assets/fonts/BrownStd-Light.otf') format('truetype'); /* IE9 Compat Modes */
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
  height: 0;
}

.team-name {
  min-width: 6rem;
  width: 6rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  white-space: normal;
  word-break: break-word;

  .stats,
  .stats-header {
    text-align: left;
    width: 100%;
  }
}

.team-pts {
  min-width: 1.2rem;
  width: 1.2rem;
}

.team-bp {
  min-width: 1.2rem;
  width: 1.2rem;
}

.team-diff {
  min-width: 1.4rem;
  width: 1.4rem;
}

/* Add base padding for all stats columns */
ion-label.stats, ion-label.stats-header {
  text-align: center;
}

ion-label.place {
  width: 1.5rem;
}

div.place {
  width: 1.75rem;
  min-width: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 0.75rem;
}

.ladder-wrapper {
  border-radius: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 1.5rem;
  background: #1e2025;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.ladder-row {
  display: flex;
  align-items: center;
  min-height: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.header-row {
  min-height: 2.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.sticky-team-info {
  display: flex;
  align-items: center;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #1e2025;
  flex-shrink: 0;
  padding-right: 0.75rem;

  .header-row & {
    z-index: 3;
  }
}

.stats-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  padding: 0.5rem 0.4rem;
  flex-shrink: 0;
}

.table-grid-container {
  min-width: 500px;
}

.logo-header {
  min-width: 94px;
}

.team-logo-column {
  min-width: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: normal;
  font-size: 0.7rem;
  line-height: 1rem;
  /* identical to box height, or 123% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

.stats-pts {
  font-family: 'BrownStd-Bold';
  font-weight: bold;
}

.pool-name {
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
}

.stats-header {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: .8rem;
  line-height: 1rem;
  /* identical to box height, or 114% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

ion-list, ion-item {
  background: transparent;
  --background: transparent;
}

.round-filter {
  // --background: #1E1E1E;
  --color: white;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  // line-height: 1rem;
  /* identical to box height, or 123% */

  // text-align: center;

  color: white;
  margin: 0 2rem 0 1rem;
}

.club-logo{
  width: 3rem;
  height: 3rem;
  border: 2px solid rgba(226, 9, 9, 0.1);
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.1s ease-in-out;
  margin-right:0.5rem;
}

/* Mobile Responsive Styles */
@media only screen and (max-width: 768px) {
  .team-name {
    min-width: 7rem;
    width: 7rem;
  }

  .team-pts {
    min-width: 3rem;
    width: 3rem;
  }

  .team-bp {
    min-width: 3rem;
    width: 3rem;
  }

  .team-diff {
    min-width: 3rem;
    width: 3rem;
  }

  .table-grid-container {
    min-width: 750px;
  }

  .ladder-wrapper {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .stats {
    font-size: 0.8rem;
    line-height: 1.1rem;
  }

  .stats-header {
    font-size: 0.85rem;
    line-height: 1.1rem;
  }

  .club-logo {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.3rem;
  }

  .logo-header {
    min-width: 80px;
  }

  .team-logo-column {
    min-width: 80px;
  }

  ion-label.stats, ion-label.stats-header {
    --padding-start: 12px;
    --padding-end: 12px;
  }

  ion-label.place {
    width: 2rem;
  }

  .place {
    width: 2rem;
  }
}

@media only screen and (max-width: 480px) {
  .team-name {
    min-width: 6.5rem;
    width: 6.5rem;
  }

  .team-pts {
    min-width: 2.8rem;
    width: 2.8rem;
  }

  .team-bp {
    min-width: 2.8rem;
    width: 2.8rem;
  }

  .team-diff {
    min-width: 2.8rem;
    width: 2.8rem;
  }

  .table-grid-container {
    min-width: 650px;
  }

  .ladder-wrapper {
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    padding-bottom: 1rem;
  }

  .stats {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .stats-header {
    font-size: 0.8rem;
    line-height: 1rem;
  }

  .club-logo {
    width: 2rem;
    height: 2rem;
    margin-right: 0.2rem;
  }

  .logo-header {
    min-width: 70px;
  }

  .team-logo-column {
    min-width: 70px;
  }

  ion-label.stats, ion-label.stats-header {
    --padding-start: 10px;
    --padding-end: 10px;
  }

  ion-label.place {
    width: 1.8rem;
  }

  .place {
    width: 1.8rem;
  }
}

@media only screen and (max-width: 375px) {
  .team-name {
    min-width: 5.5rem;
    width: 5.5rem;
  }

  .team-pts, .team-bp, .team-diff {
    min-width: 2.5rem;
    width: 2.5rem;
  }

  .table-grid-container {
    min-width: 600px;
  }

  .stats, .stats-header {
    font-size: 0.7rem;
    line-height: 0.95rem;
  }

  .club-logo {
    width: 1.8rem;
    height: 1.8rem;
  }

  .logo-header {
    min-width: 60px;
  }

  .team-logo-column {
    min-width: 60px;
  }

  ion-label.stats, ion-label.stats-header {
    --padding-start: 8px;
    --padding-end: 8px;
  }

  ion-label.place {
    min-width: 2rem;
    width: 2rem;
  }

  .place {
    min-width: 2rem;
    width: 2rem;
  }
}


</style>
